document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector(".contact__form");

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const msgBox = form.querySelector(".contact__form__message");
    const success = msgBox.querySelector(".success-message");
    const error = msgBox.querySelector(".error-message");

    const formData = new FormData(form);

    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "application/json" // upewniamy się, że serwer zwraca JSON
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Odpowiedź z PHP:", data); // DEBUG – sprawdzisz w konsoli co przyszło

        if (data.status === "sent") {
          // pokazujemy komunikat sukcesu
          success.classList.add("show");
          error.classList.remove("show");
          form.reset();
        } else {
          // pokazujemy błąd
          error.textContent = data.message || "Wystąpił błąd podczas wysyłki.";
          error.classList.add("show");
          success.classList.remove("show");
        }

        // chowamy komunikaty po 4 sekundach
        setTimeout(() => {
          success.classList.remove("show");
          error.classList.remove("show");
        }, 4000);
      })
      .catch((err) => {
        console.error("❌ Błąd w fetch:", err); // DEBUG

        error.textContent = "Błąd połączenia z serwerem.";
        error.classList.add("show");
        success.classList.remove("show");

        setTimeout(() => error.classList.remove("show"), 4000);
      });
  });
});
